import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { laboratoryProcessService } from '@/modules/configurationModule/detail/local-laboratory-module/laboratory-process/services/laboratory-process/laboratory-process.service'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { LaboratoryProcessConfigurationResponse } from '@/modules/configurationModule/detail/local-laboratory-module/laboratory-process/services/laboratory-process/laboratory-process.dto'
import { AgGridColumnFilter, AgGridColumnType } from '@/shared/models/ag-grid.model'
import { store } from '@/store/store'

export const columnsDefLaboratoryProcessGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            filter: AgGridColumnFilter.TEXT,
            headerName: i18n.tc('configuration.sections.operation'),
            colId: 'operation.code',
            field: 'operation.translatedName',
            minWidth: 250,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.NUMBER,
            headerName: i18n.tc('configuration.grid.order'),
            field: 'order',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            sortable: true
        },
        {
            type: AgGridColumnType.FLAGS_RENDERER,
            headerName: i18n.tc('configuration.grid.translations'),
            field: 'nameTranslations',
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        }
    ]

export interface LaboratoryProcessGridState extends CrudModelPaginatorLaboratory<LaboratoryProcessConfigurationResponse> {
    service: typeof laboratoryProcessService
    laboratoryId: number
}
export const initialLaboratoryProcessGridState =
    (): LaboratoryProcessGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.laboratoryModule.operations',
        columnsDef: columnsDefLaboratoryProcessGrid(),
        datasource: new PaginatorLaboratoryDatasource(laboratoryProcessService, store.getters.labId),
        service: laboratoryProcessService,
        laboratoryId: store.getters.labId
    })
